import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  updateCell(event) {
    const [_data, _status, xhr] = event.detail
    event.target.closest('td').innerHTML = xhr.response
  }
}
